"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * USCIS Verifications Identity Service
 * An [Oauth 2.0](https://tools.ietf.org/html/rfc6749) compliant API which wraps the [identity providers](https://maestro.dhs.gov/confluence/display/VERST/Identity+Providers) used in the USCIS Verifications ecosystem.
 *
 * The version of the OpenAPI document: 2.4.6
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendOtcRequestToJSON = exports.SendOtcRequestFromJSONTyped = exports.SendOtcRequestFromJSON = void 0;
var _1 = require("./");
function SendOtcRequestFromJSON(json) {
    return SendOtcRequestFromJSONTyped(json, false);
}
exports.SendOtcRequestFromJSON = SendOtcRequestFromJSON;
function SendOtcRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'emailAddress': json['email_address'],
        'clientId': json['client_id'],
        'app': _1.ApplicationFromJSON(json['app']),
    };
}
exports.SendOtcRequestFromJSONTyped = SendOtcRequestFromJSONTyped;
function SendOtcRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email_address': value.emailAddress,
        'client_id': value.clientId,
        'app': _1.ApplicationToJSON(value.app),
    };
}
exports.SendOtcRequestToJSON = SendOtcRequestToJSON;
